<ng-container *ngIf="companyId$ | async; let companyId">
  <ng-container *appLoad="let companySummary of companySummary$; errorSizeClass: 'sm'; trackingName: 'company-layout'">
    <spark-layout>

      <!-- slot / menu -->
      <layout-side-menu>

        <spark-shared-sidebar-sub-menu
          heading="Contacts"
          [backRoute]="['/Contacts']"
          [routePrefix]="routePrefix"
          [items]="items">
        </spark-shared-sidebar-sub-menu>

      </layout-side-menu>

      <!-- slot / content -->
      <layout-content>

        <div class="row">
          <div class="col company">
            <div class="company__header">
              <spark-contacts-company-summary-panel 
                [companySummary]="companySummary">
              </spark-contacts-company-summary-panel>
            </div>
            <div class="company__content">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>

      </layout-content>

    </spark-layout>
  </ng-container>
</ng-container>
